import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_170ux74pv6: FaireBrandEntity = {
  token: "b_170ux74pv6",
  type: "brand",
  name: "London Scarves",
  avatarUrl:
    "https://cdn.faire.com/fastly/87caacdb6c66b98e72c7ba729c5a733f216ae0b999c0ea6b98e5c3a34007f24f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3dd364525cc380dca7f79f58f10e67a93b42e05ab84ac675f4557168b9173443.png",
  logoUrl:
    "https://cdn.faire.com/fastly/87caacdb6c66b98e72c7ba729c5a733f216ae0b999c0ea6b98e5c3a34007f24f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3dd364525cc380dca7f79f58f10e67a93b42e05ab84ac675f4557168b9173443.png",
  location: "London, GBR",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 237,
  isTopShop: true,
  isInsider: false,
  description:
    "Based in Manchester, we are a trusted wholesale supplier of high-quality scarves, offering unbeatable prices and an extensive selection tailored for a wide range of retailers. Our customers include clothing boutiques, gift shops, home decor stores, garden centers, farm shops, hospitals, and more. We pride ourselves on delivering styles to suit every business, from cozy winter wool scarves to versatile cotton wraps, perfect for any season. Whether you're seeking timeless classics or trend-forward pieces, our collection is designed to help you meet your customers' needs while boosting your store’s appeal. Explore our Manchester-based selection for unbeatable value and quality.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:45.559Z",
    importedBy: "entity-db-cli",
  },
};
